import { render } from "./Filterable.vue?vue&type=template&id=0b42b8fe"
import script from "./Filterable.vue?vue&type=script&lang=ts"
export * from "./Filterable.vue?vue&type=script&lang=ts"
script.render = render

export default script